import { inject } from '@angular/core';

import type {
  AssistantLinkTarget,
  AssistantLinkTargetContext,
} from '@core/tellent-assistant-types';
import {
  type TellentAppKindParam,
  type TellentAppRouteID,
  type TellentPageConfig,
  ORG_GUID,
} from '@core/tellent-types';
import { injectTellentAppUrlBuilder } from '@core/tellent-util';

export function injectAssistantLinkTarget() {
  const build = injectTellentAppUrlBuilder();
  const orgGuid = inject(ORG_GUID, { optional: true });

  return (
    appKind: TellentAppKindParam,
    page: TellentPageConfig<TellentAppRouteID>,
    context?: AssistantLinkTargetContext,
  ): AssistantLinkTarget => ({
    appKind,
    page,
    url: build(appKind, page, orgGuid ?? undefined),
    ...(context ? { context } : {}),
  });
}
